import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TAligner, IDeps } from './models';
import { Aligner as Component } from './aligner';
import styles from './styles/styles.css';

export const Aligner = createWidget<IDeps, TAligner>({
    styles,
})(Component);
